import { useState } from 'react';
import { useT, type Key } from '../i18n';

/**
 * Top-right help button for low-data mode. Mirrors the position + look of
 * HUD's `?` button in Cesium mode, but shows touch-friendly instructions
 * for the 2D Leaflet map (drag/pinch/tap) instead of the FPS controls.
 */

const INSTRUCTIONS: Array<{ keys: Key; desc: Key }> = [
  { keys: 'help_drag', desc: 'help_drag_desc' },
  { keys: 'help_pinch', desc: 'help_pinch_desc' },
  { keys: 'help_tap_lot', desc: 'help_tap_lot_desc' },
];

export function LowDataInfo() {
  const { t } = useT();
  // Start open on first visit so 2D-mode controls are discoverable.
  const [open, setOpen] = useState(true);

  return (
    <div
      style={{
        position: 'absolute',
        top: 52,
        right: 16,
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        zIndex: 5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 8,
      }}
    >
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? 'Hide instructions' : 'Show instructions'}
        title={t('controls')}
        style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          border: '1px solid rgba(255,255,255,0.25)',
          background: 'rgba(0,0,0,0.62)',
          color: 'white',
          cursor: 'pointer',
          fontSize: 16,
          fontWeight: 600,
          lineHeight: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(6px)',
          WebkitBackdropFilter: 'blur(6px)',
        }}
      >
        {open ? '✕' : '?'}
      </button>
      {open && (
        <div
          style={{
            background: 'rgba(0,0,0,0.78)',
            color: 'white',
            borderRadius: 10,
            padding: '12px 14px',
            fontSize: 12,
            lineHeight: 1.6,
            minWidth: 200,
            maxWidth: 'calc(100vw - 32px)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            boxShadow: '0 6px 24px rgba(0,0,0,0.4)',
          }}
        >
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: 1.2,
              opacity: 0.6,
              marginBottom: 6,
            }}
          >
            {t('controls')}
          </div>
          {INSTRUCTIONS.map((it) => (
            <div
              key={it.keys}
              style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}
            >
              <span style={{ fontWeight: 600 }}>{t(it.keys)}</span>
              <span style={{ opacity: 0.78 }}>{t(it.desc)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
